export const LAB_ID = 6;
